import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import store from '@/stores/store';

const { getStorageKey, loadFiltersFromStorage, saveFiltersToStorage } = utils;

const state = {
    deliverysites: [],
    deliverysites_count: 0,
    deliverysites_filters: { limit: 20, ordering: 'name' },
    deliverysites_loading: false,
    deliverysites_loading_errors: null,
    deliverysites_cancel_source: null,
};

const mutations = {
    updateDeliverySites(state, deliverysites) {
        state.deliverysites = deliverysites;
    },
    updateDeliverySitesCount(state, count) {
        state.deliverysites_count = count;
    },
    updateDeliverySitesFilters(state, filters) {
        state.deliverysites_filters = filters;
        saveFiltersToStorage(getStorageKey('deliverysites', 'default'), state.deliverysites_filters);
    },
    updateDeliverySitesLoading(state, loading) {
        state.deliverysites_loading = loading;
    },
    updateDeliverySitesLoadingErrors(state, errors) {
        state.deliverysites_loading_errors = errors;
    },
    updateDeliverySitesCancelSource(state, cancel_source) {
        state.deliverysites_cancel_source = cancel_source;
    },
};

const actions = {

    async fetchDeliverySites({ commit, dispatch, state }, params) {
        if (store.getters['session/current_user_permissions'].indexOf("core.view_deliverysite") == -1) {
            return;
        }

        commit('updateDeliverySitesLoading', true);
        commit('updateDeliverySitesLoadingErrors', null);

        if (state.deliverysites_cancel_source) {
            state.deliverysites_cancel_source.cancel("canceled");
        }

        const filters = loadFiltersFromStorage(getStorageKey('deliverysites', 'default'), state.deliverysites_filters);
        commit('updateDeliverySitesFilters', filters);

        const cancelSource = axios.CancelToken.source();
        commit('updateDeliverySitesCancelSource', cancelSource);

        try {
            const response = await axios.get("/api/deliverysites/", {
                params: filters,
                cancelToken: state.deliverysites_cancel_source?.token
            });
            commit('updateDeliverySites', response.data.results);
            commit('updateDeliverySitesCount', response.data.count);
            commit('updateDeliverySitesCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateDeliverySitesLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateDeliverySitesLoading', false);
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
